import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { MatIconModule } from '@angular/material/icon';

import { selectActiveTenant, selectAuthUser } from 'src/app/auth/store/auth.selectors';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { isPlatformStaffEmail } from 'src/app/shared/utils/platform-staff.util';

@Component({
  selector: 'app-production-warning-banner',
  templateUrl: './production-warning-banner.component.html',
  styleUrls: ['./production-warning-banner.component.scss'],
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductionWarningBannerComponent {
  private store = inject(Store);

  private activeTenant = toSignal(this.store.select(selectActiveTenant));
  private user = toSignal(this.store.select(selectAuthUser));

  private exceptionSlugs = (environment.productionTenantExceptions || '')
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);

  showBanner = computed(() => {
    //if (!environment.production) return false;
    if (!this.exceptionSlugs.length) return false;
    const email = this.user()?.email?.toLowerCase() ?? '';
    if (!isPlatformStaffEmail(email)) return false;
    const tenantSlug = this.activeTenant()?.tenant?.toLowerCase();
    if (!tenantSlug) return false;
    return !this.exceptionSlugs.includes(tenantSlug);
  });

  // Prefer the federated tenantInfo.name — that is the field tenantUpdate
  // changes; AdminUserTenant.name is a deprecated denormalized copy.
  tenantName = computed(() => this.activeTenant()?.tenantInfo?.name || this.activeTenant()?.name || '');
}
